/**
  table内部cell中的动态输入组件

*/

// import objectUtil
// from "../../form-create/libs/objectUtil"
import objectUtil from '../../../static/js/objectUtil'
import dynamicItemUtil from '../../dynamicFrom/libs/dynamicItemUtil'

export default {
  name: 'editCellDynamic',
  props: {
    // cell 定义，重点判断是否有输入值组件定义
    editformItem: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Array, Object],
      default: null,
    },
    dataIndex: null,
  },
  data() {
    return {
      data: this.value,
    }
  },
  watch: {
    value(val) {
      this.data = val
    },
    // data(val) {
    //   this.$emit('input', val);
    // }
    // ,
    data: {
      handler(val) {
        // console.log("watch.value",val);
        this.$emit('input', val)
      },
      immediate: true,
      deep: true,
    },
  },
  render(h) {
    //  console.log("watch.render,this.data,this.dataIndex",this.data,this.dataIndex);
    var _vm = this
    var item = this.editformItem
    var componentCode = 'readText'
    if (item.component && item.component.code) componentCode = item.component.code

    var componentClassName = dynamicItemUtil.convertComponentName(componentCode)

    // 不再使用form-create组件
    // var componentClassName = nodes[componentCode];
    // if (!componentClassName) {
    //
    //   if(this.GLOBAL.isDebug) console.warn("render:componentClassName is null .componentCode",
    //     componentCode);
    //   componentClassName = nodes["readText"];
    //
    // }
    // var data = this.data[this.dataIndex];
    var data = this.data

    var _props = item.parameter
    var field = item.property

    // 如果设置只读模式，则优先级最高。
    if (this.disabled) {
      if (!_props) _props = {}
      _props.disabled = this.disabled
    }

    //  console.log("render:componentClassName,field,data[field]",  componentClassName, field, data[field]);

    return h(componentClassName, {
      props: _props,
      model: {
        value: objectUtil.getValueByPath(data, field),
        callback: function ($$v) {
          objectUtil.setValueByPathForVue(data, field, $$v, _vm)

          //  console.log("watch.callback,field,_vm.dataIndex",field,$$v,_vm.dataIndex);

          // objectUtil.setValueByPath(data, field, $$v);

          //
          // var firstProperty = objectUtil.getFirstPropertyOfPath(data,
          //   field);
          //
          // console.log("watch.callback,field,_vm.dataIndex", field, $$v,
          //   firstProperty);
          // if (firstProperty == field) {
          //   //  _vm.$set 不支持多级路径设值,使用它解决没有该属性没定义的情况也能设值成功
          //   _vm.$set(_vm.data, field, $$v);
          // } else {
          //   // _vm.$set(_vm.data, "field", {
          //   //   ttttttttt: $$v
          //   // });
          //
          //
          //   var firstPropertyData = objectUtil.setValueByPathForVue(data,
          //     field,
          //     $$v, _vm);
          //   // //目前有缺陷该对属性没定义时，不能触发双向绑定。
          //   // var firstPropertyData = objectUtil.setValueByPath(data, field,
          //   //   $$v);
          //   // //_vm.$forceUpdate();
          //   // _vm.$set(_vm.data, firstProperty, firstPropertyData);
          // }

          //  _vm.$set(_vm.data, field, $$v);
          // _vm.$set(_vm.data, _vm.dataIndex, data);
        },
      },
    })
  },
}
